import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { useSEO } from "../lib/seo";
import { login } from "../lib/auth";

export default function AdminLogin() {
  useSEO({ title: "Acceso · Panel de Victoria Fuentes", description: "Acceso privado.", path: "/acceso", noindex: true });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/panel");
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo iniciar sesión.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-2xl border border-ink/10 bg-white px-5 py-3.5 text-base text-ink placeholder:text-ink-muted focus:border-sage focus:outline-none focus:ring-2 focus:ring-sage/30";

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-secondary px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-4xl border border-ink/10 bg-bg-primary p-8 md:p-10" data-testid="admin-login-form">
        <div className="mb-8 flex h-14 w-14 items-center justify-center rounded-full bg-bg-sage">
          <Lock className="h-6 w-6 text-sage-dark" strokeWidth={1.5} />
        </div>
        <h1 className="font-serif text-3xl text-ink">Panel privado</h1>
        <p className="mt-2 text-sm text-ink-soft">Acceso exclusivo para Victoria Fuentes.</p>
        <div className="mt-8 space-y-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" aria-label="Email" data-testid="admin-email" className={inputCls} />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" aria-label="Contraseña" data-testid="admin-password" className={inputCls} />
        </div>
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-ink px-8 py-4 text-sm font-medium text-bg-primary transition-colors duration-300 hover:bg-sage-dark disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}
          {loading ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
